
import { combineEpics } from "redux-observable";

import * as LoginEpic from "./login.epic";
import * as ForumEpic from "./forum.epic";
import * as MembersEpic from "./members.epic";
import * as ResourceEpic from "./resources.epic";
import * as SiteDataEpic from './siteData.epic';
import * as PeopleEpic from './people.epic';
import * as NewsEpic from './news.epic';
import * as ResearchEpic from './research.epic';
import * as PublicationsEpic from './publications.epic';
import * as HomeSettingsEpic from './homeSettings.epic';
import * as AboutUsSettingsEpic from './aboutUsSettings.epic';
import * as ContactUsSettingsEpic from './contactUsSettings.epic';

export const rootEpic = combineEpics(
    LoginEpic.loginEpic,
    LoginEpic.logoutEpic, 
    LoginEpic.loginValidateEpic,
    LoginEpic.resetPasswordEpic,
    LoginEpic.resetPasswordUpdateEpic,
    
    ForumEpic.getForumsEpic, 
    ForumEpic.getForumEpic, 
    ForumEpic.getForumDataEpic, 
    ForumEpic.getForumUpdateEpic, 
    ForumEpic.saveForumEpic, 
    ForumEpic.saveTagEpic, 
    ForumEpic.loadPostEpic,
    ForumEpic.savePostEpic,
    ForumEpic.savePostTagEpic, 
    ForumEpic.saveForumPostReactionEpic,
    ForumEpic.searchEpic, 
    ForumEpic.searchPostEpic, 
    ForumEpic.followPostEpic,
    ForumEpic.subscribeEpic,
    
    ResourceEpic.saveResouceEpic, 
    ResourceEpic.searchResourceEpic, 
    ResourceEpic.flagResouceEpic,  
    ResourceEpic.saveResourceTagEpic,
    ResourceEpic.sortResourceEpic,

    MembersEpic.getMemberEpic,
    MembersEpic.saveMemberEpic, 
    MembersEpic.searchMemberEpic, 
    MembersEpic.setNotificationActiveEpic,
    MembersEpic.setNotificationFrequencyEpic,

    PeopleEpic.peopleRequestEpic,
    PeopleEpic.peopleUpsertRequestEpic,
    PeopleEpic.peopleUpsertRequestSuccessEpic,
    PeopleEpic.peopleUpsertRequestSuccessNotificationEpic,
    PeopleEpic.peopleUpsertRequestErrorNotificationEpic,
    PeopleEpic.peopleUpsertRequestSuccessSiteDataEpic,

    NewsEpic.newsRequestEpic,
    NewsEpic.newsUpsertRequestEpic,
    NewsEpic.newsUpsertRequestSuccessEpic,
    NewsEpic.newsUpsertRequestSuccessNotificationEpic,
    NewsEpic.newsUpsertRequestErrorNotificationEpic,
    NewsEpic.newsUpsertRequestSuccessSiteDataEpic,

    ResearchEpic.researchRequestEpic,
    ResearchEpic.researchUpsertRequestEpic,
    ResearchEpic.researchUpsertRequestSuccessEpic,
    ResearchEpic.researchUpsertRequestSuccessNotificationEpic,
    ResearchEpic.researchUpsertRequestErrorNotificationEpic,
    ResearchEpic.researchUpsertRequestSuccessSiteDataEpic,

    PublicationsEpic.publicationsRequestEpic,
    PublicationsEpic.publicationUpsertRequestEpic,
    PublicationsEpic.publicationUpsertRequestSuccessEpic,
    PublicationsEpic.publicationUpsertRequestSuccessNotificationEpic,
    PublicationsEpic.publicationUpsertRequestErrorNotificationEpic,
    PublicationsEpic.publicationUpsertRequestSuccessSiteDataEpic,

    HomeSettingsEpic.homeSettingsRequestEpic,
    HomeSettingsEpic.homeSettingsUpsertRequestEpic,
    HomeSettingsEpic.homeSettingsUpsertRequestSuccessEpic,
    HomeSettingsEpic.homeSettingsUpsertRequestSuccessNotificationEpic,
    HomeSettingsEpic.homeSettingsUpsertRequestErrorNotificationEpic,
    HomeSettingsEpic.homeSettingsUpsertRequestSuccessSiteDataEpic,

    AboutUsSettingsEpic.aboutUsSettingsRequestEpic,
    AboutUsSettingsEpic.aboutUsSettingsUpsertRequestEpic,
    AboutUsSettingsEpic.aboutUsSettingsUpsertRequestSuccessEpic,
    AboutUsSettingsEpic.aboutUsSettingsUpsertRequestSuccessNotificationEpic,
    AboutUsSettingsEpic.aboutUsSettingsUpsertRequestErrorNotificationEpic,
    AboutUsSettingsEpic.aboutUsSettingsUpsertRequestSuccessSiteDataEpic,

    ContactUsSettingsEpic.contactUsSettingsRequestEpic,
    ContactUsSettingsEpic.contactUsSettingsUpsertRequestEpic,
    ContactUsSettingsEpic.contactUsSettingsUpsertRequestSuccessEpic,
    ContactUsSettingsEpic.contactUsSettingsUpsertRequestSuccessNotificationEpic,
    ContactUsSettingsEpic.contactUsSettingsUpsertRequestErrorNotificationEpic,
    ContactUsSettingsEpic.contactUsSettingsUpsertRequestSuccessSiteDataEpic,

    SiteDataEpic.getSiteDataEpic
    
);


// WEBPACK FOOTER //
// ./src/epics/index.ts